import { actions } from './actions'

const initialState = {
  logs: {
    data: [],
    loading: false,
    error: '',
  },
  jobConfigs: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function jobsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOGS_LOAD_REQUESTED:
      return { ...state, logs: { ...state.logs, loading: true } }
    case actions.LOGS_LOAD_SUCCEEDED:
      return { ...state, logs: { ...state.logs, data: action.payload, loading: false } }
    case actions.LOGS_LOAD_FILED:
      return { ...state, logs: { ...state.logs, loading: false, error: action.error } }
    case actions.JOB_CONFIGS_LOAD_REQUESTED:
      return { ...state, jobConfigs: { ...state.jobConfigs, loading: true } }
    case actions.JOB_CONFIGS_LOAD_SUCCEEDED:
      return { ...state, jobConfigs: { ...state.jobConfigs, data: action.payload, loading: false } }
    case actions.JOB_CONFIGS_LOAD_FAILED:
      return { ...state, jobConfigs: { ...state.jobConfigs, loading: false, error: action.error } }
    default:
      return state
  }
}
